export default __webpack_public_path__ + "static/media/Diego_Villarán.1df6e416.jpeg";